import React from "react";

import { Tag } from "~/components/tag";
import { Truncated } from "~/components/truncated";
import { useScope } from "~/tools/impulse";
import type { ImpulseFormUnit } from "~/tools/impulse-form";

import type { FormState } from "./_form-state";
import { ListVariablePreview } from "./_list-variable";

export interface PreviewProps {
	name: ImpulseFormUnit<string, unknown, string>;
	state: FormState;
}

export const Preview: React.FC<PreviewProps> = ({ name, state }) => {
	const scope = useScope();
	const activeType = state.fields.type.getActiveBranch(scope);

	if (activeType?.kind === "TextVariable") {
		return (
			<Tag disabled>
				<Truncated>{activeType.value.fields.value.getOutput(scope) || "\u00A0"}</Truncated>
			</Tag>
		);
	}

	if (activeType?.kind === "ListVariable") {
		return <ListVariablePreview name={name} state={activeType.value} />;
	}

	return null;
};
